import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import M from "materialize-css";

const Dashboard = (props) => {

  //  if (!props.auth.uid) return <Redirect to="/login" />;
  return (
    <div className='container'>
      <h1 className='catchphrase row center'> Help is only a click away </h1>
      {/* <div className='row container' style={{ marginTop: '5%' }}>
        <div className="col s10 offset-s1">
          <LocationDrop handleLocationSelect={(location) => alert(location)} />
        </div>
      </div> */}
      <h6 className="white-text row center"> Providing various services in Kolkata and surrounding areas</h6>
      <div className="row">
        <div className="col s12 m4">
          <div className="card sticky-action">
            <div className="card-image">
              <img className="activator" src="images/homecare2.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Home Care</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Home Care<i className="material-icons right">close</i></span>
              <p> Hire a professional for caregiving services like assisted living, nursing care and elderly care.</p></div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
        <div className="col s12 m4">
          <div className="card sticky-action">
            <div className="card-image">
              <img className="activator" src="images/beautician.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Wellness</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Wellness<i className="material-icons right">close</i></span>
              <p> Hire a professional for at-home salon services for men or women.</p></div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
        <div className="col s12 m4">
          <div className="card">
            <div className="card-image">
              <img className="activator" src="images/cleaning.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Maid Service</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Maid Service<i className="material-icons right">close</i></span>
              <p> Hire a professional for cleaning, cooking and other daily chores.</p> </div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col s12 m4">
          <div className="card">
            <div className="card-image">
              <img className="activator" src="images/childcare.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Child Care</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Maid Service<i className="material-icons right">close</i></span>
              <p> Hire a professional for taking care of your child.</p> </div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
        <div className="col s12 m4">
          <div className="card">
            <div className="card-image">
              <img className="activator" src="images/cook.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Home Cook</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Maid Service<i className="material-icons right">close</i></span>
              <p> Hire a professional for cooking your meal daily.</p> </div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
        <div className="col s12 m4">
          <div className="card">
            <div className="card-image">
              <img className="activator" src="images/maid.jpg" />
              <Link to="/book" className="btn-floating halfway-fab waves-effect waves-light red"><i className="material-icons">arrow_forward</i></Link>
            </div>
            <div className="card-content">
              <span className="card-title activator">Bathroom Cleaning</span>
            </div>
            <div className="card-reveal">
              <span className="card-title">Maid Service<i className="material-icons right">close</i></span>
              <p> Hire a professional for cleaning your bathroom.</p> </div>
            <div className="card-action center">
              <Link to="/book">Book Now</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
//  auth: state.firebase.auth
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
